import React from 'react';

import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Spacing from '@marvelapp/marvel-ui/spacing';

import Feature from 'marketing-website/components/modules/Feature';
import HeadingBlock from 'marketing-website/components/modules/HeadingBlock';

import assets from 'marketing-website/configs/pages/developers/assets';

export default function Features() {
  return (
    <PageWrap>
      <Spacing size="l" sizeM="xl" position="topBottom" type="padding">
        <Spacing sizeM="l" position="topBottom" type="margin">
          <HeadingBlock
            align="center"
            alignContent="center"
            alignM="center"
            color="white"
            copy="You can now harness components of our platform and build powerful integrations for our 2 million users - or simply just for your team."
            title="Experience the freedom to build features, right away."
          />
        </Spacing>
        <Grid columns={3} size="l" sizeM="xl">
          <GridItem columnSpan={3} columnSpanM={1} alignContent="center">
            <Feature
              {...assets.team}
              title="Dedicated API Team"
              copy="Our team are available to answer questions via our Slack Developer Community and Email."
              maxWidth={360}
              maxImageWidth={250}
              fontWeight="semibold"
              alignM="center"
              copyColor="silver"
              headingColor="white"
            />
          </GridItem>
          <GridItem columnSpan={3} columnSpanM={1} alignContent="center">
            <Feature
              {...assets.graphQL}
              title="Our API uses GraphQL"
              copy="Giving you the flexibility to select all the data you need with a single request."
              maxWidth={360}
              maxImageWidth={250}
              fontWeight="semibold"
              alignM="center"
              copyColor="silver"
              headingColor="white"
            />
          </GridItem>
          <GridItem columnSpan={3} columnSpanM={1} alignContent="center">
            <Feature
              {...assets.workflow}
              title="Supercharge your workflow"
              copy="Automate workflows, extract designs and analyse data to take Marvel to the next level."
              maxWidth={360}
              maxImageWidth={250}
              fontWeight="semibold"
              alignM="center"
              copyColor="silver"
              headingColor="white"
            />
          </GridItem>
        </Grid>
      </Spacing>
    </PageWrap>
  );
}



// WEBPACK FOOTER //
// ./src/pages/developers/Features.js